import { render } from "./PersonalDataStep.vue?vue&type=template&id=593d3ef6"
import script from "./PersonalDataStep.vue?vue&type=script&lang=js"
export * from "./PersonalDataStep.vue?vue&type=script&lang=js"

import "./PersonalDataStep.vue?vue&type=style&index=0&id=593d3ef6&lang=css"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__